import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-btnShow",
  "use": "icon-btnShow-usage",
  "viewBox": "0 0 40 48",
  "content": "<symbol viewBox=\"0 0 40 48\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-btnShow\">\n    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->\n    <title>01btn_show</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-btnShow_Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-btnShow_01btn_show\" fill=\"#889AA4\">\n            <g id=\"icon-btnShow_btn_eye\">\n                <path d=\"M20,30 C14.477,30 10,27.537 10,24.5 C10,21.462 14.477,19 20,19 C25.523,19 30,21.462 30,24.5 C30,27.537 25.523,30 20,30 Z M20,20 C15.582,20 12,22.014 12,24.5 C12,26.985 15.582,29 20,29 C24.418,29 28,26.985 28,24.5 C28,22.014 24.418,20 20,20 Z\" id=\"icon-btnShow_Shape\" />\n                <circle id=\"icon-btnShow_Oval\" fill-rule=\"nonzero\" cx=\"20\" cy=\"24\" r=\"3\" />\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/btnShow.svg
// module id = mnPi
// module chunks = 35